module.exports = __webpack_public_path__ + "img/case3.d3a88a49.png";